// export const ignoreSpacesAndUrlsFromMsg = (message) => {
//   const msgStr = message ? message : "";
//   let inputDataLen = msgStr.length;
//   const inputText = msgStr?.replace(/\n/g, " ");
//   const strArray = inputText.split(" ");
//   let validLetterCount = 0;
//   let i;

//   for (i = 0; i < strArray.length; i++) {
//     if (
//       strArray[i].indexOf("http://") == -1 &&
//       strArray[i].indexOf("www.") == -1 &&
//       strArray[i].indexOf("https://") == -1 &&
//       strArray[i].indexOf("HTTP://") == -1 &&
//       strArray[i].indexOf("WWW.") == -1 &&
//       strArray[i].indexOf("HTTPS://") == -1
//     ) {
//       validLetterCount = validLetterCount + strArray[i].length;
//     } else if (
//       strArray[i].indexOf("http://") &&
//       strArray[i].indexOf("www.") &&
//       strArray[i].indexOf("https://") &&
//       strArray[i].indexOf("HTTP://") &&
//       strArray[i].indexOf("WWW.") &&
//       strArray[i].indexOf("HTTPS://")
//     ) {
//       validLetterCount = validLetterCount + strArray[i].length;
//     }
//   }

//   inputDataLen = validLetterCount;

//   return {
//     msgLength: inputDataLen,
//     hasMessage: msgStr?.length > 0,
//   };
// };

//I implemented below functionality so that user can post link also and space should count after character as per requirement

// export const ignoreSpacesAndUrlsFromMsg = (message) => {
//   const msgStr = message || ""; // fallback to empty string

//   // Step 1: remove URLs (http, https, www + up to next space)
//   const msgWithoutUrls = msgStr.replace(
//     /(https?:\/\/[^\s]+|www\.[^\s]+)/gi,
//     ""
//   );

//   // Step 2: trim leading spaces
//   const trimmedMsg = msgWithoutUrls.trimStart();

//   // Step 3: count remaining characters
//   const validCharCount = trimmedMsg.length;

//   return {
//     msgLength: validCharCount,
//     hasMessage: validCharCount > 0,
//   };
// };

export const ignoreSpacesAndUrlsFromMsg = (message) => {
  const msgStr = (message || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");

  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

  // Check if message contains a URL
  const hasUrl = urlRegex.test(msgStr);

  // Remove URLs
  const msgWithoutUrls = msgStr.replace(urlRegex, "");

  // Trim leading spaces
  const trimmedMsg = msgWithoutUrls.trimStart();

  let validCharCount = trimmedMsg.length;

  // If only URL is present, count it as 1
  if (validCharCount === 0 && hasUrl) {
    validCharCount = 1;
  }

  return {
    msgLength: validCharCount,
    hasMessage: validCharCount > 0,
  };
};


export const replaceTagAndUrl = (Message, msg, tags, urls, callback) => {
  if (msg && Array.isArray(urls) && urls.length) {
    return <div>{createMarkup(msg, urls)}</div>;
  } else if (msg && Array.isArray(tags) && tags.length && callback) {
    // Create a regular expression to match the hashtags
    const regex = new RegExp(`(${tags.join("|")})`, "g");

    const handleTagClick = (tag) => {
      console.log(`Tag clicked: ${tag}`);
      callback && callback(tag);
    };

    // Split the message and map over it to replace hashtags with <a> tags
    const parts = msg.split(regex).map((part, index) => {
      if (part && tags.includes(part)) {
        return (
          <a
            key={index}
            href={`#${part.slice(1)}`}
            onClick={(e) => {
              e.preventDefault(); // Prevent default anchor behavior
              handleTagClick(part); // Call the onTagClick handler with the tag
            }}
          >
            {part}
          </a>
        );
      }
      return part;
    });

    return <div>{parts}</div>;
  } else {
    return Message;
  }
};

export const createMarkup = (msg, urls) => {
  const urlRegex = /(\bhttps?:\/\/[^\s/$.?#].[^\s]*|\bwww\.[^\s/$.?#].[^\s]*)/g;
  const isUrlRegex = /^(https?:\/\/|www\.|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)(\/|\b|\?|#))/i;
  const urlList = Array.isArray(urls)
    ? urls
    : typeof urls === "string" && urls
    ? [urls]
    : [];

  const msgArray = msg ? msg.split(urlRegex) : [];
  return msgArray.map((part, index) => {
    if ((urlList.length > 0 && urlList.includes(part)) || isUrlRegex.test(part)) {
      let url = part;
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + part;
      }
      // For each URL, wrap it in an anchor tag
      return (
        <a key={index} href={url} target="_blank" rel="noopener noreferrer">
          related link
        </a>
      );
    }
    return part; // If it's not a URL, return the part of the string as plain text
  });
};

export function capitalizeFirstLetter(value) {
  let inputText = value ? String(value) : "";

  const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)/i;
  const match = inputText.match(urlRegex);

  // If starts with URL
  if (match) {
    const urlPart = match[0].toLowerCase(); // only URL forced lowercase
    const remainingText = inputText.slice(match[0].length); // user input untouched
    return urlPart + remainingText;
  }

  // Non-URL text → capitalize first letter
  return inputText.charAt(0).toUpperCase() + inputText.slice(1);
}

export const isChildSayMessageType = (type) => {
  if (!type) return false;
  const normalized = String(type).trim().toLowerCase();
  return (
    normalized === "answer" ||
    normalized === "reply" ||
    normalized === "childsay" ||
    normalized === "w" ||
    normalized === "p"
  );
};

export const updateItemSayCount = (list = [], id, operator) => {
  return list.map((item) => {
    if (String(item.id) === String(id)) {
      const currentCount = Number(item.sayCount) || 0;
      const newCount =
        operator === "add" ? currentCount + 1 : Math.max(0, currentCount - 1);
      return { ...item, sayCount: newCount };
    }
    return item;
  });
};
